import {
  CognitoIdentityProviderClient,
  ListUsersCommand,
} from "@aws-sdk/client-cognito-identity-provider";
import { fetchAuthSession } from "aws-amplify/auth";

const {
  REACT_APP_REGION,
  REACT_APP_CUSTOMER_POOL_ID,
} = process.env;

const handler = async ({ user_id }, { rejectWithValue }) => {
  try {
    const { credentials } = await fetchAuthSession();

    const client = new CognitoIdentityProviderClient({
      region: REACT_APP_REGION,
      credentials,
    });

    const res = await client.send(
      new ListUsersCommand({
        UserPoolId: REACT_APP_CUSTOMER_POOL_ID,
        Filter: `sub = "${user_id}"`,
        Limit: 1,
      }),
    );

    const user = (res.Users || [])[0];
    if (!user) return null;

    const attrs = {};
    (user.Attributes || []).forEach((a) => {
      attrs[a.Name] = a.Value;
    });

    return {
      sub: attrs.sub,
      name: attrs.name || [attrs.given_name, attrs.family_name].filter(Boolean).join(" "),
      email: attrs.email,
      phone_number: attrs.phone_number,
      status: user.UserStatus,
      enabled: user.Enabled,
    };
  } catch (error) {
    console.error("services.customers.getCustomer@handler", error);
    return rejectWithValue(error.message || "Failed to load customer");
  }
};

export default { handler };
